<template>
  <div class="mgt-20px">
    <div class="columns is-mobile" v-if="dateDernierExport">
      <div class="column is-4">
        <div class="card shadow">
          <div class="level pd-10px">
            <div class="level-left has-text-default">
              <p> {{$t('ecritureCompta.dateTransfere')}} </p>
            </div>
            <div class="level-right has-text-weight-bold">
              <p> {{dateDernierExport | formatDate}} </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-for="ecriture in ecritures" :key="ecriture.id">
      <Ecriture :data="ecriture" />
    </div>
  </div>
</template>

<script>
import Ecriture from '@/components/commun/ecritureComptable/ecritureCompta';

export default {
  props: {
    dateDernierExport: {
      type: String,
      required: false,
      default: '',
    },
    ecritures: {
      type: Array,
      required: true,
    },
  },
  components: {
    Ecriture,
  },
};
</script>
